import Axios from '../Axios'

const transaction = {
  read(limit = 10, page = 1, search) {
    return Axios.get('/requests?limit=' + limit + '&page=' + page + search)
  },
}

export default transaction
